import Vue from "vue";
import Router from "vue-router";
import IndexPage from "@/page/IndexPage";
import Login from "@/page/Login";
import vote from "@/page/vote";
import question from "@/page/question";
import subway from "@/page/subway";
import highway from "@/page/highway";
import schoolDistrict from "@/page/schoolDistrict";
import drawArea from "@/page/drawArea";
import backup from "@/page/backup";
import management from "@/page/management";
import RealTable from "@/page/RealTable";
import fastNews from "@/page/FastNews";
import landPlan from "@/page/LandPlan";
import drawLand from "@/page/DrawLand";
import dealWant from "@/page/DealWant";
import mapMenu from "@/page/MapMenu";
import other from "@/page/Other";
import system from "@/page/System";
import landDeal from "@/page/LandDeal";
import AutoReply from "@/page/AutoReply.vue";
import ChatGroup from "@/page/ChatGroup.vue";
import GeoChat from "@/page/GeoChat.vue";
import Shop from "@/page/Shop.vue";
import Product from "@/page/Product.vue";
import PoiInformation from "@/page/poiInformation";
import opinion from "@/page/opinion.vue";
import HouseType from "@/page/HouseType.vue";
import UpDataApp from "@/page/UpDataApp.vue";
import FireGroup from "@/page/FireGroup.vue";
import YunYinCount from "@/page/yunYincount.vue";
import shujuCount from "@/page/shujuCount.vue";
import xiaoshouCount from "@/page/xiaoshouCount.vue";
import officialAgent from "@/page/officialAgent.vue";
import giveCustomers from "@/page/giveCustomers.vue";
import getDataInfo from "@/page/getDataInfo.vue";
import finishTable from "@/page/finishTable.vue";
import MapImage from "@/page/MapImage.vue";
import PriceChangeAnalysis from "@/page/priceChangeAnalysis.vue";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/consultButtonClickData",
      name: "consultButtonClickData",
      component: () => import("@/page/ConsultButtonClickData.vue"),
    },
    {
      path: "/performance-monitor",
      name: "performanceMonitor",
      component: () => import("@/page/PerformanceMonitor.vue"),
    },
    {
      path: "/estateAIAnalysis",
      name: "estateAIAnalysis",
      component: () => import("@/page/EstateAIAnalysis.vue"),
    },
    {
      path: "/intelligentHouse",
      name: "intelligentHouse",
      component: () => import("@/page/intelligentHouse.vue"),
    },
    {
      path: "/decorationCompanyConsult",
      name: "decorationCompanyConsult",
      component: () => import("@/page/decorationCompanyConsult.vue"),
    },
    // 报告中心：周刊 / 月刊 · 杭州 / 区域 / 板块 统一列表
    {
      path: "/reportCenter",
      name: "reportCenter",
      component: () => import("@/page/ReportCenter/ReportCenter.vue"),
    },
    // 旧入口兼容：保留 query 并映射到报告中心（报告渲染页路由不变）
    {
      path: "/monthlyReport",
      name: "monthlyReport",
      redirect: (to) => {
        const query = Object.assign({}, to.query)
        const district = query.district && query.district !== "全市" ? query.district : ""
        delete query.district
        query.type = "monthly"
        if (district) {
          query.scope = "district"
          query.district = district
        } else {
          query.scope = "city"
        }
        return { path: "/reportCenter", query: query }
      },
    },
    {
      path: "/monthlyReportView",
      name: "monthlyReportView",
      component: () => import("@/page/MonthlyReport/MonthlyReportView.vue"),
    },
    // 板块分析指南：一区一册，页序由 book.toc / boards[].layout 驱动
    // 独立路由（不复用 monthlyReportView）：本刊无期号 / pagePlan，数据结构与三种月刊模式不同
    {
      path: "/blockGuideView",
      name: "blockGuideView",
      component: () => import("@/page/MonthlyReport/guide/GuideView.vue"),
    },
    // 学区房指南：一区一册（西湖 / 拱墅 / 上城 / 滨江 / 外围），页序由 book.pages 驱动
    // 独立路由（不复用 monthlyReportView）：本刊无期号 / pagePlan，数据契约见学区房指南数据契约 §4
    {
      path: "/schoolGuideView",
      name: "schoolGuideView",
      component: () => import("@/page/MonthlyReport/schoolGuide/SchoolGuideView.vue"),
    },
    // 板块月刊旧入口：一板块一期，预览复用 monthlyReportView（query 带 block）
    {
      path: "/blockMonthlyReport",
      name: "blockMonthlyReport",
      redirect: (to) => {
        const query = Object.assign({}, to.query)
        query.type = "monthly"
        query.scope = "block"
        return { path: "/reportCenter", query: query }
      },
    },
    // 杭州周报旧入口：周报只支持杭州
    {
      path: "/weeklyReport",
      name: "weeklyReport",
      redirect: (to) => {
        const query = Object.assign({}, to.query)
        delete query.district
        query.type = "weekly"
        query.scope = "city"
        return { path: "/reportCenter", query: query }
      },
    },
    {
      path: "/weeklyReportView",
      name: "weeklyReportView",
      component: () => import("@/page/WeeklyReport/WeeklyReportView.vue"),
    },
    {
      path: "/decorationPlan",
      name: "decorationPlan",
      component: () => import("@/page/DecorationPlan.vue"),
    },
    {
      path: "/decorationPlanAudit",
      name: "decorationPlanAudit",
      component: () => import("@/page/DecorationPlanAudit.vue"),
    },
    {
      path: "/employee",
      component: () => import("@/page/Employee.vue"),
    },
    {
      path: "/brandStore",
      component: () => import("@/page/brandStore.vue"),
    },
    {
      path: "/crlist",
      component: () => import("@/page/estate/crlist.vue"),
    },
    {
      path: "/secondHandHandNotify",
      component: () => import("@/page/secondHandHandNotify.vue"),
    },
    {
      path: "/annualActivityPrizeStatistics",
      component: () => import("@/page/annualActivityPrizeStatistics.vue"),
    },
    {
      path: "/annualEventStatsTable",
      component: () => import("@/page/annualEventStatsTable.vue"),
    },
    {
      path: "/annualActivityPropertyVoting",
      component: () => import("@/page/annualActivityPropertyVoting.vue"),
    },
    {
      path: "/brokerAllocateUser",
      component: () => import("@/page/brokerAllocateUser.vue"),
    },
    {
      path: "/discountsExamineNew",
      component: () => import("@/page/discountsExamineNew.vue"),
    },
    {
      path: "/brokerHouseManage",
      component: () => import("@/page/brokerHouseManage/index.vue"),
    },
    {
      path: "/fdbrokerHouseManage",
      component: () => import("@/page/fdbrokerHouseManage/index.vue"),
    },
    {
      path: "/ownerUploadPropertyCheck",
      component: () => import("@/page/ownerUploadPropertyCheck.vue"),
    },
    {
      path: "/brokerHouseTypeCheck",
      component: () => import("@/page/brokerHouseTypeCheck.vue"),
    },
    {
      path: "/SecondHandHouseTable",
      component: () => import("@/page/SecondHandHouseTable.vue"),
    },
    {
      path: "/propertyPolicy",
      name: "propertyPolicy",
      component: () => import("@/page/propertyPolicy.vue"),
    },
    {
      path: "/reservationShowings",
      component: () => import("@/page/reservationShowings.vue"),
    },
    {
      path: "/privateCallback",
      component: () => import("@/page/privateCallback.vue"),
    },
    {
      path: "/fourthBooth",
      component: () => import("@/page/fourthBooth.vue"),
    },
    {
      path: "/intelligenceSelectTopic",
      component: () => import("@/page/intelligenceSelectTopic.vue"),
    },
    {
      path: "/versionTips",
      component: () => import("@/page/versionTips/index.vue"),
    },
    {
      path: "/houseVideoCheck",
      name: "houseVideoCheck",
      component: () => import("@/page/houseVideoCheck.vue"),
    },
    {
      path: "/addExperience",
      component: () => import("@/page/addExperience.vue"),
    },
    {
      path: "/estateDynamics",
      component: () => import("@/page/estateDynamics.vue"),
    },
    {
      path: "/ManageAffarisTables",
      component: () => import("@/page/ManageAffarisTables.vue"),
    },
    {
      path: "/uploadHouseExamine",
      component: () => import("@/page/uploadHouseExamine.vue"),
    },
    {
      path: "/manageProperties",
      component: () => import("@/page/manageProperties.vue"),
    },
    {
      path: "/houseGuestDirectData",
      component: () => import("@/page/houseGuestDirectData.vue"),
    },
    {
      path: "/guwenHoutaikb",
      component: () => import("@/page/guwenHoutaikb.vue"),
    },
    {
      path: "/houseGuestDirectChatDetail",
      component: () => import("@/page/houseGuestDirectChatDetail.vue"),
    },
    {
      path: "/houseGuestDirectOwnerDetail",
      component: () => import("@/page/houseGuestDirectOwnerDetail.vue"),
    },
    {
      path: "/chickenPopcornDetails",
      component: () => import("@/page/chickenPopcornDetails.vue"),
    },
    {
      path: "/jmh2DataStatis",
      component: () => import("@/page/jmh2DataStatis.vue"),
    },
    {
      path: "/propertyCompetition",
      component: () => import("@/page/propertyCompetition.vue"),
    },
    {
      path: "/chickenPopcornStats",
      component: () => import("@/page/chickenPopcornStats.vue"),
    },
    {
      path: "/sourceCompetition",
      component: () => import("@/page/sourceCompetition.vue"),
    },
    {
      path: "/exchangeDetails",
      component: () => import("@/page/exchangeDetails.vue"),
    },
    {
      path: "/uploadRunEstateVR",
      component: () => import("@/page/uploadRunEstateVR.vue"),
    },
    {
      path: "/verifyVideoCheck",
      component: () => import("@/page/verifyVideoCheck.vue"),
    },
    {
      path: "/reportSechouseModify",
      component: () => import("@/page/reportSechouseModify.vue"),
    },
    {
      path: "/dataMonitoring",
      component: () => import("@/page/dataMonitoring.vue"),
    },
    {
      path: "/saleScoreDetail",
      component: () => import("@/page/saleScoreDetail.vue"),
    },
    {
      path: "/saleActivityList",
      name: "saleActivityList",
      component: () => import("@/page/saleActivityList.vue"),
    },
    {
      path: "/estateExpertStatis",
      component: () => import("@/page/estateExpertStatis.vue"),
    },
    {
      path: "/agentCreditScore",
      component: () => import("@/page/agentCreditScore.vue"),
    },
    {
      path: "/agentVR",
      component: () => import("@/page/agentVR.vue"),
    },
    {
      path: "/uploadHouseModify",
      component: () => import("@/page/uploadHouseModify.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/uploadFangdongHouseModify",
      component: () => import("@/page/uploadFangdongHouseModify.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/houseEstateVideoCheck",
      name: "houseEstateVideoCheck",
      component: () => import("@/page/houseEstateVideoCheck.vue"),
    },
    {
      path: "/brokerJoinExamine",
      component: () => import("@/page/brokerJoinExamine.vue"),
    },
    {
      path: "/storeManageModify",
      component: () => import("@/page/storeManageModify.vue"),
    },
    {
      path: "/adPublication",
      component: () => import("@/page/adPublication.vue"),
    },
    {
      path: "/adScreen",
      name: "adScreen",
      component: () => import("@/page/AdScreen.vue"),
    },
    {
      path: "/estate-manager",
      component: () => import("@/page/EstateManager.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/schoolTwoHouseDeal",
      component: () => import("@/page/schoolTwoHouseDeal.vue"),
    },
    {
      path: "/EstateManager",
      component: () => import("@/page/EstateManager.vue"),
    },
    {
      path: "/estateChatSearch",
      component: () => import("@/page/estateChatSearch.vue"),
    },
    {
      path: "/areaTwoHouseHighestDeal",
      component: () => import("@/page/areaTwoHouseHighestDeal.vue"),
    },
    {
      path: "/beikeSechandHouse",
      component: () => import("@/page/beikeSechandHouse.vue"),
    },
    {
      path: "/areaTwoHouseMoonDeal",
      component: () => import("@/page/areatwoHouseMoonDeal.vue"),
    },
    {
      path: "/expectStartExcel",
      component: () => import("@/page/expectStartExcel.vue"),
    },
    {
      path: "/discountsExamine",
      component: () => import("@/page/discountsExamine.vue"),
    },
    {
      path: "/departureFeedback",
      component: () => import("@/page/departureFeedback.vue"),
    },
    {
      path: "/endyearActivities/prize",
      component: () => import("@/page/endyearActivities/prize.vue"),
    },
    {
      path: "/endyearActivities/consultantStatistic",
      component: () =>
        import("@/page/endyearActivities/consultantStatistic.vue"),
    },
    {
      path: "/agent/invitation/detail",
      component: () => import("@/page/agentInviteDetail.vue"),
    },
    {
      path: "/agent/houseupload/detail",
      component: () => import("@/page/agentHouseuploadDetail.vue"),
    },
    {
      path: "/agent/agentshare/detail",
      component: () => import("@/page/agentShareDetail.vue"),
    },
    {
      path: "/endyearActivities/addTickets",
      component: () => import("@/page/endyearActivities/addTickets.vue"),
    },
    {
      path: "/endyearActivities/flowAnaly",
      component: () => import("@/page/endyearActivities/flowAnaly.vue"),
    },
    {
      path: "/endyearActivities/consultantTrack",
      component: () => import("@/page/endyearActivities/consultantTrack.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/endyearActivities/statistics",
      component: () => import("@/page/endyearActivities/statistics.vue"),
    },
    {
      path: "/assignCustomerRecords",
      name: "assignCustomerRecords",
      component: () => import("@/page/assignCustomerRecords.vue"),
    },
    {
      path: "/preventBrushscore",
      name: "preventBrushscore",
      component: () => import("@/page/preventBrushscore.vue"),
    },
    {
      path: "/agentDealChampionPoster",
      name: "agentDealChampionPoster",
      component: () => import("@/page/agentDealChampionPoster.vue"),
    },
    {
      path: "/agentPosterDealdata",
      name: "agentPosterDealdata",
      component: () => import("@/page/agentPosterDealdata.vue"),
    },
    {
      path: "/addAgentStore",
      name: "addAgentStore",
      component: () => import("@/page/addAgentStore.vue"),
    },
    {
      path: "/saleConsultFromData",
      name: "saleConsultFromData",
      component: () => import("@/page/saleConsultFromData.vue"),
    },
    {
      path: "/userInteractionData",
      name: "userInteractionData",
      component: () => import("@/page/userInteractionData.vue"),
    },
    {
      path: "/manualGroupbuying",
      name: "manualGroupbuying",
      component: () => import("@/page/manualGroupbuying.vue"),
    },
    {
      path: "/sendInviteCard",
      name: "sendInviteCard",
      component: () => import("@/page/sendInviteCard.vue"),
    },
    {
      path: "/AgentTopup",
      name: "AgentTopup",
      component: () => import("@/page/AgentTopup.vue"),
    },
    {
      path: "/AgentStoreAudit",
      name: "AgentStoreAudit",
      component: () => import("@/page/AgentStoreAudit.vue"),
    },
    {
      path: "/houseSelectService",
      name: "houseSelectService",
      component: () => import("@/page/houseSelectService/index.vue"),
    },
    {
      path: "/featuredListings",
      name: "featuredListings",
      component: () => import("@/page/featuredListings/index.vue"),
    },
    {
      path: "/estateTagManage",
      name: "estateTagManage",
      component: () => import("@/page/estateTagManage/index.vue"),
    },
    {
      path: "/fyReportModify",
      name: "fyReportModify",
      component: () => import("@/page/fyReportModify.vue"),
    },
    {
      path: "/scoreRecordHandle",
      name: "scoreRecordHandle",
      component: () => import("@/page/scoreRecordHandle.vue"),
    },
    {
      path: "/MapScreenshot",
      name: "MapScreenshot",
      component: () => import("@/page/MapScreenshot.vue"),
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/articleAdapt",
      name: "articleAdapt",
      component: () => import("@/page/articleAdapt.vue"),
    },
    {
      path: "/dealCount",
      name: "dealCount",
      component: () => import("@/page/dealCount.vue"),
    },
    {
      path: "/shareConsultation",
      name: "shareConsultation",
      component: () => import("@/page/shareConsultation.vue"),
    },
    {
      path: "/backRateDetail",
      name: "backRateDetail",
      component: () => import("@/page/backRateDetail.vue"),
    },
    {
      path: "/voiceClone",
      name: "voiceClone",
      component: () => import("@/page/voiceClone/index.vue"),
    },
    {
      path: "/intelligenceComment",
      name: "intelligenceComment",
      component: () => import("@/page/intelligenceComment.vue"),
    },
    {
      path: "/intelligenceArticle",
      name: "intelligenceArticle",
      component: () => import("@/page/intelligenceArticle.vue"),
    },
    {
      path: "/estateReviewArticle",
      name: "estateReviewArticle",
      component: () => import("@/page/estateReviewArticle.vue"),
    },
    {
      path: "/estateRateCount",
      name: "estateRateCount",
      component: () => import("@/page/estateRateCount.vue"),
    },
    {
      path: "/EstateValueMap",
      name: "EstateValueMap",
      component: () => import("@/page/EstateValueMap.vue"),
    },
    {
      path: "/feedbackQuestion",
      name: "feedbackQuestion",
      component: () => import("@/page/feedback/feedbackQuestion.vue"),
    },
    {
      path: "/feedbackCount",
      name: "feedbackCount",
      component: () => import("@/page/feedback/feedbackCount.vue"),
    },
    {
      path: "/userChatHistory",
      name: "userChatHistory",
      component: () => import("@/page/userChatHistory.vue"),
    },
    {
      path: "/twoHouseExtent",
      name: "twoHouseExtent",
      component: () => import("@/page/twoHouseExtent.vue"),
    },
    {
      path: "/newHouseExtent",
      name: "newHouseExtent",
      component: () => import("@/page/newHouseExtent.vue"),
    },
    {
      path: "/deleteEstate",
      name: "deleteEstate",
      component: () => import("@/page/deleteEstate.vue"),
    },
    {
      path: "/transactionContract",
      name: "transactionContract",
      component: () => import("@/page/transactionContract.vue"),
    },
    {
      path: "/asiaGamesComment",
      name: "asiaGamesComment",
      component: () => import("@/page/asiaGames/asiaGamesComment.vue"),
    },
    {
      path: "/asiaGamesQuestion",
      name: "asiaGamesQuestion",
      component: () => import("@/page/asiaGames/asiaGamesQuestion.vue"),
    },
    {
      path: "/asiaGamesPreheat",
      name: "asiaGamesPreheat",
      component: () => import("@/page/asiaGames/asiaGamesPreheat.vue"),
    },
    {
      path: "/asiaGamesMedal",
      name: "asiaGamesMedal",
      component: () => import("@/page/asiaGames/asiaGamesMedal.vue"),
    },
    {
      path: "/countSharevisit",
      name: "countSharevisit",
      component: () => import("@/page/xinghao/countSharevisit.vue"),
    },
    {
      path: "/estateAsManage",
      name: "estateAsManage",
      component: () => import("@/page/estateAsManage.vue"),
    },
    {
      path: "/automaticAddLPQuestion",
      name: "automaticAddLPQuestion",
      component: () =>
        import(
          "@/page/newOperateTeam/components/components/automaticAddLPQuestion.vue"
        ),
    },
    {
      path: "/questionCount",
      name: "questionCount",
      component: () =>
        import("@/page/newOperateTeam/components/components/questionCount.vue"),
    },
    {
      path: "/secondHandEvaluate",
      name: "secondHandEvaluate",
      component: () =>
        import(
          "@/page/newOperateTeam/components/components/secondHandEvaluate.vue"
        ),
    },
    {
      path: "/fakerToAgent",
      name: "fakerToAgent",
      component: () =>
        import("@/page/newOperateTeam/components/components/fakerToAgent.vue"),
    },
    {
      path: "/createWXShareTask",
      name: "createWXShareTask",
      component: () =>
        import(
          "@/page/newOperateTeam/components/components/createWXShareTask.vue"
        ),
    },
    {
      path: "/createSharedTask",
      name: "createSharedTask",
      component: () =>
        import(
          "@/page/newOperateTeam/components/components/createSharedTask.vue"
        ),
    },
    {
      path: "/addLPQuestion",
      name: "addLPQuestion",
      component: () =>
        import("@/page/newOperateTeam/components/components/addLPQuestion.vue"),
    },
    {
      path: "/addLSQuestion",
      name: "addLSQuestion",
      component: () =>
        import("@/page/newOperateTeam/components/components/addLSQuestion.vue"),
    },
    {
      path: "/shamMessages",
      name: "shamMessages",
      component: () =>
        import("@/page/newOperateTeam/components/components/shamMessages.vue"),
    },
    {
      path: "/haterIdentify",
      name: "haterIdentify",
      component: () => import("@/page/haterIdentify.vue"),
    },
    {
      path: "/businessPlanTrail",
      name: "businessPlanTrail",
      component: () => import("@/page/business/businessPlanTrail.vue"),
    },
    {
      path: "/uploadAd",
      name: "uploadAd",
      component: () => import("@/page/business/uploadAd.vue"),
    },
    {
      path: "/checkAd",
      name: "checkAd",
      component: () => import("@/page/business/checkAd.vue"),
    },
    {
      path: "/routineTrail",
      name: "routineTrail",
      component: () => import("@/page/business/routineTrail.vue"),
    },
    {
      path: "/propertyReview",
      name: "propertyReview",
      component: () => import("@/page/propertyReview.vue"),
    },
    {
      path: "/communityFacilityAudit",
      name: "communityFacilityAuditList",
      component: () => import("@/page/communityFacilityAuditList.vue"),
    },
    {
      path: "/communityFacilityAudit/detail",
      name: "communityFacilityAudit",
      component: () => import("@/page/communityFacilityAudit.vue"),
    },
    {
      path: "/propertyModify",
      name: "propertyModify",
      component: () => import("@/page/propertyModify.vue"),
    },
    {
      path: "/openingTask",
      name: "openingTask",
      component: () => import("@/page/openingTask.vue"),
    },
    //新运营小队 其他页下功能
    {
      path: "/cooperateAccount",
      name: "cooperateAccount",
      component: () => import("@/page/cooperateAccount.vue"),
    },
    {
      path: "/homeClickTotal",
      name: "homeClickTotal",
      component: () => import("@/page/homeClickTotal.vue"),
    },
    {
      path: "/saleActiveState",
      name: "saleActiveState",
      component: () => import("@/page/saleActiveState.vue"),
    },
    {
      path: "/saleTrendsCount",
      name: "saleTrendsCount",
      component: () => import("@/page/saleTrendsCount.vue"),
    },
    {
      path: "/saleWeekIntegral",
      name: "saleWeekIntegral",
      component: () => import("@/page/saleWeekIntegral.vue"),
    },
    {
      path: "/saleWeekShare",
      name: "saleWeekShare",
      component: () => import("@/page/saleWeekShare.vue"),
    },
    {
      path: "/brokerChat",
      name: "brokerChat",
      component: () => import("@/page/brokerChat.vue"),
    },
    {
      path: "/saleConsulTrank",
      name: "saleConsulTrank",
      component: () => import("@/page/saleConsulTrank.vue"),
    },
    {
      path: "/biddingRecords",
      name: "biddingRecords",
      component: () => import("@/page/biddingRecords.vue"),
    },
    {
      path: "/estateConsulTrank",
      name: "estateConsulTrank",
      component: () => import("@/page/estateConsulTrank.vue"),
    },
    {
      path: "/twoHouseImgExamine",
      name: "twoHouseImgExamine",
      component: () => import("@/page/twoHouseImgExamine.vue"),
    },
    {
      path: "/twoHouseClickTotal",
      name: "twoHouseClickTotal",
      component: () => import("@/page/twoHouseClickTotal.vue"),
    },
    {
      path: "/estateDictionaryList",
      name: "estateDictionaryList",
      component: () => import("@/page/estateDictionaryList.vue"),
    },
    {
      path: "/estateDictionaryCheck",
      name: "estateDictionaryCheck",
      component: () => import("@/page/estateDictionaryCheck.vue"),
    },
    {
      path: "/estateDictionaryDetail",
      name: "estateDictionaryDetail",
      component: () => import("@/page/estateDictionaryDetail.vue"),
    },
    {
      path: "/estateDealData",
      name: "estateDealData",
      component: () => import("@/page/estateDealData.vue"),
    },
    {
      path: "/cooperateAccountShare",
      name: "cooperateAccountShare",
      component: () => import("@/page/cooperateAccountShare.vue"),
    },
    {
      path: "/nowPublicity",
      name: "nowPublicity",
      component: () => import("@/page/nowPublicity.vue"),
    },
    {
      path: "/occupancyInfo",
      name: "occupancyInfo",
      component: () => import("@/page/occupancyInfo.vue"),
    },
    {
      path: "/addBroker",
      name: "addBroker",
      component: () => import("@/page/addBroker.vue"),
    },
    {
      path: "/userdataStatis",
      name: "userdataStatis",
      component: () => import("@/page/userdataStatis.vue"),
    },
    {
      path: "/propertyInfoCompleteness",
      name: "propertyInfoCompleteness",
      component: () => import("@/page/propertyInfoCompleteness.vue"),
    },
    {
      path: "/opsIdentityToggle",
      name: "opsIdentityToggle",
      component: () => import("@/page/opsIdentityToggle.vue"),
    },
    {
      path: "/fixedBooth",
      name: "fixedBooth",
      component: () => import("@/page/fixedBooth.vue"),
    },
    {
      path: "/topRatedPropertiesPage",
      name: "topRatedPropertiesPage",
      component: () => import("@/page/topRatedPropertiesPage.vue"),
    },
    {
      path: "/agentActivityStatistics",
      name: "agentActivityStatistics",
      component: () => import("@/page/agentActivityStatistics.vue"),
    },
    {
      path: "/agentBenefitsData",
      name: "agentBenefitsData",
      component: () => import("@/page/agentBenefitsData.vue"),
    },
    {
      path: "/agentUploadRecord",
      name: "agentUploadRecord",
      component: () => import("@/page/agentUploadRecord.vue"),
    },
    {
      path: "/estateImportDataModify",
      name: "estateImportDataModify",
      component: () => import("@/page/estateImportDataModify.vue"),
    },
    {
      path: "/feedbackAppModify",
      name: "feedbackAppModify",
      component: () => import("@/page/feedbackAppModify.vue"),
    },
    {
      path: "/agentInviteManage",
      name: "agentInviteManage",
      component: () => import("@/page/agentInviteManage.vue"),
    },
    {
      path: "/agentNotice",
      name: "agentNotice",
      component: () => import("@/page/agentNotice.vue"),
    },
    {
      path: "/secondhandClick",
      name: "secondhandClick",
      component: () => import("@/page/secondhandClick.vue"),
    },
    {
      path: "/agentInvitation",
      name: "agentInvitation",
      component: () => import("@/page/agentInvitation.vue"),
    },
    {
      path: "/agentHouseUpload",
      name: "agentHouseUpload",
      component: () => import("@/page/agentHouseUpload.vue"),
    },
    {
      path: "/secondSubwaySale",
      name: "secondSubwaySale",
      component: () => import("@/page/secondSubwaySale.vue"),
    },
    {
      path: "/secondSchoolSale",
      name: "secondSchoolSale",
      component: () => import("@/page/secondSchoolSale.vue"),
    },
    {
      path: "/secondDistrictSale",
      name: "secondDistrictSale",
      component: () => import("@/page/secondDistrictSale.vue"),
    },
    {
      path: "/areanameDataSummary",
      name: "areanameDataSummary",
      component: () => import("@/page/areanameDataSummary.vue"),
    },
    {
      path: "/schoolDataSummary",
      name: "schoolDataSummary",
      component: () => import("@/page/schoolDataSummary.vue"),
    },
    {
      path: "/agentShareSituation",
      name: "agentShareSituation",
      component: () => import("@/page/agentShareSituation.vue"),
    },
    {
      path: "/houseUploadData",
      name: "houseUploadData",
      component: () => import("@/page/houseUploadData.vue"),
    },
    {
      path: "/agentUploadData",
      name: "agentUploadData",
      component: () => import("@/page/agentUploadData.vue"),
    },
    {
      path: "/agentStatis",
      name: "agentStatis",
      component: () => import("@/page/agentStatis.vue"),
    },
    {
      path: "/areaHouseStatis",
      name: "areaHouseStatis",
      component: () => import("@/page/areaHouseStatis.vue"),
    },
    {
      path: "/houseDataStatis",
      name: "houseDataStatis",
      component: () => import("@/page/HouseDataStatis.vue"),
    },
    {
      path: "/recentlyEnterTotal",
      name: "recentlyEnterTotal",
      component: () => import("@/page/recentlyEnterTotal.vue"),
    },
    {
      path: "/saleGroupChat",
      name: "saleGroupChat",
      component: () => import("@/page/saleGroupChat.vue"),
    },
    {
      path: "/trackPublicityEstate",
      name: "trackPublicityEstate",
      component: () => import("@/page/trackPublicityEstate.vue"),
    },
    {
      path: "/estateReservation",
      name: "estateReservation",
      component: () => import("@/page/estateReservation.vue"),
    },
    {
      path: "/villageCollocation",
      name: "villageCollocation",
      component: () => import("@/page/villageCollocation.vue"),
    },
    {
      path: "/addCollocation",
      name: "addCollocation",
      component: () => import("@/page/addCollocation.vue"),
    },
    {
      path: "/presaleInfo",
      name: "presaleInfo",
      component: () => import("@/page/presaleInfo.vue"),
    },
    {
      path: "/areaSaleShare",
      name: "areaSaleShare",
      component: () => import("@/page/areaSaleShare.vue"),
    },
    {
      path: "/WeChatCount",
      name: "WeChatCount",
      component: () => import("@/page/WeChatCount.vue"),
    },
    {
      path: "/estateMatching",
      name: "estateMatching",
      component: () => import("@/page/estateMatching.vue"),
    },
    {
      path: "/groupChat",
      name: "groupChat",
      component: () => import("@/page/groupChat.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/topicCategory",
      name: "topicCategory",
      component: () => import("@/page/topicCategory.vue"),
    },
    {
      path: "/groupChatcomplete",
      name: "groupChatcomplete",
      component: () => import("@/page/groupChatcomplete.vue"),
    },
    {
      path: "/returnReward",
      component: () =>
        import("@/page/newOperateTeam/components/returnRewardDashboard.vue"),
    },
    //新运营小队
    {
      path: "/newOperateTeam",
      name: "newOperateTeam",
      component: () => import("@/page/newOperateTeam/index.vue"),
      meta: {
        keepAlive: true,
      },
      children: [
        {
          path: "/newOperateTeam/customerSumTable",
          component: () =>
            import("@/page/newOperateTeam/components/customerSumTable.vue"),
        },
        {
          path: "/newOperateTeam/customerShare",
          component: () =>
            import("@/page/newOperateTeam/components/customerShare.vue"),
        },
        {
          path: "/newOperateTeam/customerGroupchat",
          component: () =>
            import("@/page/newOperateTeam/components/customerGroupchat.vue"),
        },
        {
          path: "/newOperateTeam/customerTopic",
          component: () =>
            import("@/page/newOperateTeam/components/customerTopic.vue"),
        },
        {
          path: "/newOperateTeam/customerQuestion",
          component: () =>
            import("@/page/newOperateTeam/components/customerQuestion.vue"),
        },
        {
          path: "/newOperateTeam/summaryTable",
          component: () =>
            import("@/page/newOperateTeam/components/summaryTable.vue"),
        },
        {
          path: "/newOperateTeam/examine",
          component: () =>
            import("@/page/newOperateTeam/components/examine.vue"),
        },
        {
          path: "/newOperateTeam/share",
          component: () => import("@/page/newOperateTeam/components/share.vue"),
        },
        {
          path: "/newOperateTeam/addScore",
          component: () =>
            import("@/page/newOperateTeam/components/addScore.vue"),
        },
        {
          path: "/newOperateTeam/other",
          component: () => import("@/page/newOperateTeam/components/other.vue"),
        },
        {
          path: "/newOperateTeam/brokerIndex",
          component: () =>
            import("@/page/newOperateTeam/components/brokerIndex.vue"),
        },
        {
          path: "/newOperateTeam/workMap/hangzhou-subway",
          component: () =>
            import(
              "@/page/newOperateTeam/components/workMaps/NewEstateSubwayMap.vue"
            ),
          meta: {
            title: "杭州新房地铁分布图",
          },
        },
        {
          path: "/newOperateTeam/workMap/low-density-estate",
          component: () =>
            import(
              "@/page/newOperateTeam/components/workMaps/LowDensityEstateMap.vue"
            ),
          meta: {
            title: "低密楼盘分布地图",
          },
        },
        {
          path: "/newOperateTeam/workMap/luxury-estate",
          component: () =>
            import(
              "@/page/newOperateTeam/components/workMaps/LuxuryEstateMap.vue"
            ),
          meta: {
            title: "豪宅楼盘分布地图",
          },
        },
        {
          path: "/newOperateTeam/workMap/plate-plan-analysis",
          component: () =>
            import(
              "@/page/newOperateTeam/components/workMaps/PlatePlanAnalysisMap.vue"
            ),
          meta: {
            title: "板块规划分析图",
          },
        },
      ],
    },
    // 上海
    {
      path: "/shanghai/homePage",
      name: "homePage",
      component: () => import("@/page/shanghai/homePage.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/brokerJoin",
      component: () => import("@/page/shanghai/brokerJoin.vue"),
    },
    {
      path: "/shanghai/shDrawWarn",
      component: () => import("@/page/shanghai/shDrawWarn.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/departureFeedbackSH",
      component: () => import("@/page/shanghai/departureFeedbackSH.vue"),
    },
    {
      path: "/shanghai/statisticalTable",
      component: () => import("@/page/shanghai/statisticalTable.vue"),
    },
    {
      path: "/shanghai/estateGroupManage",
      name: "estateGroupManage",
      component: () => import("@/page/shanghai/estateGroupManage.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/groupWater",
      name: "groupWater",
      component: () => import("@/page/shanghai/groupWater.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/estateCollection",
      name: "estateCollection",
      component: () => import("@/page/shanghai/estateCollection.vue"),
    },
    {
      path: "/shanghai/estateList",
      name: "estateList",
      component: () => import("@/page/shanghai/estateList.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/drawAreas",
      name: "drawAreas",
      component: () => import("@/page/shanghai/drawAreas.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/landEdit",
      name: "landEdit",
      component: () => import("@/page/shanghai/landEdit.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/indentityEdit",
      name: "indentityEdit",
      component: () => import("@/page/shanghai/indentityEdit.vue"),
    },
    {
      path: "/shanghai/addScoreRecord",
      name: "addScoreRecord",
      component: () => import("@/page/shanghai/addScoreRecord.vue"),
    },
    {
      path: "/shanghai/highWayTwo",
      name: "highWayTwo",
      component: () => import("@/page/shanghai/highWayTwo.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/estateInfo",
      name: "estateInfo",
      component: () => import("@/page/shanghai/estateInfo.vue"),
    },
    {
      path: "/shanghai/estatePeitaoEdit",
      name: "estatePeitaoEdit",
      component: () => import("@/page/shanghai/estatePeitaoEdit.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/estatePictures",
      name: "estatePictures",
      component: () => import("@/page/shanghai/estatePictures.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/estateAnnouncement",
      name: "estateAnnouncement",
      component: () => import("@/page/shanghai/estateAnnouncement.vue"),
    },
    {
      path: "/shanghai/drawSchool",
      name: "drawSchool",
      component: () => import("@/page/shanghai/drawSchool.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/areaEdit",
      name: "areaEdit",
      component: () => import("@/page/shanghai/areaEdit.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/subWay",
      name: "subWay",
      component: () => import("@/page/shanghai/subWay.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/estateEdit",
      name: "estateEdit",
      component: () => import("@/page/shanghai/estateEdit.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/saleApproval",
      name: "saleApproval",
      component: () => import("@/page/shanghai/saleApproval.vue"),
    },
    {
      path: "/shanghai/sHtimeLimitedAcitivity",
      name: "sHtimeLimitedAcitivity",
      component: () => import("@/page/shanghai/sHtimeLimitedAcitivity.vue"),
    },
    {
      path: "/shanghai/shActivityEdit",
      name: "shActivityEdit",
      component: () => import("@/page/shanghai/shActivityEdit.vue"),
    },
    {
      path: "/shanghai/salesDynamicApproval",
      name: "salesDynamicApproval",
      component: () => import("@/page/shanghai/salesDynamicApproval.vue"),
    },
    {
      path: "/shanghai/removeBan",
      name: "removeBan",
      component: () => import("@/page/shanghai/removeBan.vue"),
    },
    {
      path: "/shanghai/userManageRecord",
      name: "userManageRecord",
      component: () => import("@/page/shanghai/userManageRecord.vue"),
    },
    {
      path: "/shanghai/propertyReviewApproval",
      name: "propertyReviewApproval",
      component: () => import("@/page/shanghai/propertyReviewApproval.vue"),
    },
    {
      path: "/shanghai/verifyApproval",
      name: "verifyApproval",
      component: () => import("@/page/shanghai/verifyApproval.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/articleManage",
      name: "articleManage",
      component: () => import("@/page/shanghai/articleManage.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/articleEdit",
      name: "articleEdit",
      component: () => import("@/page/shanghai/articleEdit.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/shTopic",
      name: "shTopic",
      component: () => import("@/page/shanghai/shTopic.vue"),
    },
    {
      path: "/shanghai/shTopicList",
      name: "shTopicList",
      component: () => import("@/page/shanghai/shTopicList.vue"),
    },
    {
      path: "/shanghai/publicAccount",
      name: "publicAccount",
      component: () => import("@/page/shanghai/publicAccount.vue"),
    },
    {
      path: "/shanghai/propertyReviewModify",
      name: "propertyReviewModify",
      component: () => import("@/page/shanghai/propertyReviewModify.vue"),
    },
    {
      path: "/shanghai/shareAddScore",
      name: "shareAddScore",
      component: () => import("@/page/shanghai/shareAddScore.vue"),
    },
    {
      path: "/shanghai/gasStationCheck",
      name: "gasStationCheck",
      component: () => import("@/page/shanghai/gasStationCheck.vue"),
    },
    {
      path: "/shanghai/sHlandPlan",
      name: "sHlandPlan",
      component: () => import("@/page/shanghai/sHlandPlan.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/sHdrawLand",
      name: "sHdrawLand",
      component: () => import("@/page/shanghai/sHdrawLand.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/unbindRecoed",
      name: "unbindRecoed",
      component: () => import("@/page/shanghai/unbindRecoed.vue"),
    },
    {
      path: "/shanghai/chatReport",
      name: "chatReport",
      component: () => import("@/page/shanghai/chatReport.vue"),
    },
    {
      path: "/shanghai/gasStationTask",
      name: "gasStationTask",
      component: () => import("@/page/shanghai/gasStationTask.vue"),
    },
    {
      path: "/shanghai/photoCheck",
      name: "photoCheck",
      component: () => import("@/page/shanghai/photoCheck.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/shareInfo",
      name: "shareInfo",
      component: () => import("@/page/shanghai/shareInfo.vue"),
    },
    {
      path: "/shanghai/shamMessages",
      name: "shamMessages",
      component: () => import("@/page/shanghai/shamMessages.vue"),
    },
    {
      path: "/shanghai/hangPai",
      name: "shhangPai",
      component: () => import("@/page/shanghai/hangPai.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/adEdit",
      name: "adEdit",
      component: () => import("@/page/shanghai/adEdit.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/avatarReview",
      name: "avatarReview",
      component: () => import("@/page/shanghai/avatarReview.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/newEstateCompleteness",
      name: "newEstateCompleteness",
      component: () => import("@/page/shanghai/newEstateCompleteness.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/saleIdentityBind",
      name: "saleIdentityBind",
      component: () => import("@/page/shanghai/saleIdentityBind.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/saleShareLook",
      name: "saleShareLook",
      component: () => import("@/page/shanghai/saleShareLook.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/demolitionMap",
      name: "demolitionMap",
      component: () => import("@/page/shanghai/demolitionMap.vue"),
    },
    {
      path: "/shanghai/fakerToSale",
      name: "fakerToSale",
      component: () => import("@/page/shanghai/fakerToSale.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/guwenManage",
      name: "guwenManage",
      component: () => import("@/page/shanghai/guwenManage.vue"),
    },
    {
      path: "/shanghai/ShRevieTotal",
      name: "ShRevieTotal",
      component: () => import("@/page/shanghai/ShRevieTotal.vue"),
    },
    {
      path: "/shanghai/evaluationTotal",
      name: "evaluationTotal",
      component: () => import("@/page/shanghai/evaluationTotal.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/intelligentEvaluation",
      name: "intelligentEvaluation",
      component: () => import("@/page/shanghai/intelligentEvaluation.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/userEstateEvaluation",
      name: "userEstateEvaluation",
      component: () => import("@/page/shanghai/userEstateEvaluation.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/userChatHis",
      name: "userChatHis",
      component: () => import("@/page/shanghai/userChatHis.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/estateEvaluation",
      name: "estateEvaluation",
      component: () => import("@/page/shanghai/estateEvaluation.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/addScoreStatistics",
      name: "addScoreStatistics",
      component: () => import("@/page/shanghai/addScoreStatistics.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/uploadData",
      name: "uploadData",
      component: () => import("@/page/shanghai/uploadData.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/shanghai/saleShareDetail",
      name: "saleShareDetail",
      component: () => import("@/page/shanghai/saleShareDetail.vue"),
      meta: {
        keepAlive: true,
      },
    },
    // 新商务小队
    {
      path: "/newBusinessTeam",
      name: "newBusinessTeam",
      component: () => import("@/page/newBusinessTeam/index.vue"),
      meta: {
        keepAlive: true,
      },
      children: [
        {
          path: "/newBusinessTeam/businessCustomerSum",
          component: () =>
            import("@/page/newBusinessTeam/components/businessCustomerSum.vue"),
        },
        {
          path: "/newBusinessTeam/businessCustomerDetail",
          component: () =>
            import(
              "@/page/newBusinessTeam/components/businessCustomerDetail.vue"
            ),
        },
        {
          path: "/newBusinessTeam/businessAgentDetail",
          component: () =>
            import("@/page/newBusinessTeam/components/businessAgentDetail.vue"),
        },
      ],
    },
    {
      path: "/newBusinessTeam/businessAdvertisement",
      name: "businessAdvertisement",
      component: () =>
        import("@/page/newBusinessTeam/businessAdvertisement.vue"),
    },
    {
      path: "/infoOfflineManage",
      name: "infoOfflineManage",
      component: () => import("@/page/infoOfflineManage.vue"),
    },
    {
      path: "/couponManage",
      component: () => import("@/page/couponManage.vue"),
    },
    {
      path: "/activityCustomerList",
      component: () => import("@/page/activityCustomerList.vue"),
    },
    {
      path: "/dealSubsidy",
      component: () => import("@/page/dealSubsidy.vue"),
    },
    {
      path: "/businessIfoUpload",
      component: () => import("@/page/businessIfoUpload.vue"),
    },
    {
      path: "/renovationManage",
      component: () => import("@/page/renovationManage.vue"),
    },
    {
      path: "/businessInfoShow",
      component: () => import("@/page/businessInfoShow.vue"),
    },
    {
      path: "/emotionRecord",
      component: () => import("@/page/emotionRecord/index.vue"),
    },
    {
      path: "/pointsMall",
      component: () => import("@/page/pointsMall/index.vue"),
    },
    {
      path: "/taskaudit/audit",
      component: () => import("@/page/timedTask/audit.vue"),
    },
    {
      path: "/tourlistMap",
      component: () => import("@/page/tourlistMap.vue"),
    },
    {
      path: "/storeMap",
      component: () => import("@/page/storeMap.vue"),
    },
    {
      path: "/communityCheck",
      component: () => import("@/page/communityCheck.vue"),
    },
    {
      path: "/districtMayor",
      component: () => import("@/page/districtMayor.vue"),
    },
    {
      path: "/communityLocationData",
      component: () => import("@/page/communityLocationData.vue"),
    },
    {
      path: "/communityComplaintList",
      component: () => import("@/page/communityComplaintList.vue"),
    },
    {
      path: "/xjxqDataBoard",
      component: () => import("@/page/xjxqDataBoard.vue"),
    },
    {
      path: "/taskaudit",
      component: () => import("@/page/timedTask/index.vue"),
    },
    {
      path: "/toLandVR",
      component: () => import("@/page/LandVR.vue"),
    },
    {
      path: "/ErrRedPacket",
      component: () => import("@/page/RedPacket/ErrRedPacket.vue"),
    },
    {
      path: "/peopleLocation",
      component: () => import("@/page/store/storePeopleLocation.vue"),
    },
    {
      path: "/createPeopleLocation",
      component: () => import("@/page/store/createStorePeopleLocation.vue"),
    },
    {
      path: "/agentConsumeTable",
      component: () => import("@/page/agentConsumeTable.vue"),
    },
    {
      path: "/renewalDashboard",
      component: () => import("@/page/renewalDashboard.vue"),
    },
    {
      path: "/store",
      component: () => import("@/page/store/index.vue"),
    },
    {
      path: "/storeLocation",
      component: () => import("@/page/store/storeLocation.vue"),
    },
    {
      path: "/createStore",
      component: () => import("@/page/store/createStore.vue"),
    },
    {
      path: "/createLocation",
      component: () => import("@/page/store/createLocation.vue"),
    },
    {
      path: "/createHxStore",
      component: () => import("@/page/store/createHxStore.vue"),
    },
    {
      path: "/hxStore",
      component: () => import("@/page/store/storeHX.vue"),
    },
    {
      path: "/xHGuanS",
      component: () => import("@/page/xHGuanS.vue"),
    },
    {
      path: "/finishTable",
      component: finishTable,
    },
    {
      path: "/topicRecord",
      name: "topicRecord",
      component: () => import("@/page/topicRecord.vue"),
    },
    {
      path: "/noteInfo",
      name: "noteInfo",
      component: () => import("@/page/noteInfo.vue"),
    },
    {
      path: "/millionInfo",
      name: "millionInfo",
      component: () => import("@/page/millionInfo.vue"),
    },
    {
      path: "/topicContentQuery",
      name: "topicContentQuery",
      component: () => import("@/page/topicContentQuery.vue"),
    },
    {
      path: "/competitorsAddata",
      name: "competitorsAddata",
      component: () => import("@/page/competitorsAddata.vue"),
    },
    {
      path: "/estatePreferentialBooth",
      name: "estatePreferentialBooth",
      component: () => import("@/page/estatePreferentialBooth.vue"),
    },
    {
      path: "/surveyQuestionnaire",
      name: "surveyQuestionnaire",
      component: () => import("@/page/surveyQuestionnaire.vue"),
    },
    {
      path: "/bannerControl",
      name: "bannerControl",
      component: () => import("@/page/bannerControl.vue"),
    },
    {
      path: "/CustomerServicedata",
      name: "CustomerServicedata",
      component: () => import("@/page/CustomerServicedata.vue"),
    },
    {
      path: "/diversionAppData",
      name: "diversionAppData",
      component: () => import("@/page/diversionAppData.vue"),
    },
    {
      path: "/xiaojiEmoji",
      name: "xiaojiEmoji",
      component: () => import("@/page/xiaojiEmoji.vue"),
    },
    {
      path: "/bankDiet",
      component: () => import("@/page/operation/bankDiet.vue"),
    },
    {
      path: "/RedPacket",
      component: () => import("@/page/RedPacket/index.vue"),
    },
    {
      path: "/redpacketAudit",
      component: () => import("@/page/redpacketAudit/index.vue"),
    },
    {
      path: "/RedPacketStatistics",
      component: () => import("@/page/RedPacket/redPacketStatistics"),
    },
    {
      path: "/chooseQuse",
      component: () => import("@/page/chooseQuse.vue"),
    },
    {
      path: "/checkAIAns",
      name: "checkAIAns",
      component: () => import("@/page/statisticTeam/checkAIAns.vue"),
    },
    {
      path: "/messageStatic",
      name: "messageStatic",
      component: () => import("@/page/statisticTeam/messageStatic.vue"),
    },
    {
      path: "/judegcomment",
      component: () =>
        import("@/page/operateTeam/newHouse/customerReview/judegcomment.vue"),
    },
    {
      path: "/judgeReview",
      component: () =>
        import("@/page/operateTeam/newHouse/customerReview/judgeReview.vue"),
    },
    {
      path: "/salesDynamic",
      component: () =>
        import("@/page/operateTeam/newHouse/consultantReview/salesDynamic.vue"),
    },
    {
      path: "/newHouseMonitor",
      component: () =>
        import(
          "@/page/operateTeam/newHouse/consultantReview/newHouseMonitor.vue"
        ),
    },
    {
      path: "/liveAudit",
      component: () =>
        import("@/page/operateTeam/newHouse/customerReview/liveAudit.vue"),
    },
    {
      path: "/chuangxinCount",
      component: () => import("@/page/chuangxinCount.vue"),
    },
    {
      path: "/getDataInfo",
      component: getDataInfo,
    },
    {
      path: "/xiaoshouCount",
      component: xiaoshouCount,
    },
    {
      path: "/officialAgent",
      component: officialAgent,
    },
    {
      path: "/giveCustomers",
      component: giveCustomers,
    },
    {
      path: "/giveCuctomersRecord",
      component: () => import("@/page/giveCuctomersRecord.vue"),
    },
    {
      path: "/shujuCount",
      component: shujuCount,
    },
    {
      path: "/yunYincount",
      component: YunYinCount,
    },
    {
      path: "/UpDataApp",
      component: UpDataApp,
    },
    {
      path: "/HouseType",
      component: HouseType,
    },
    {
      path: "/recentLottery",
      name: "recentLottery",
      component: () => import("@/page/recentLottery.vue"),
    },

    {
      path: "/IndexPage",
      name: "index-page",
      component: IndexPage,
      meta: {
        keepAlive: true,
        // requiresAuth: true
      },
    },
    {
      path: "/poiInformation",
      component: PoiInformation,
    },
    {
      path: "/realEstate",
      name: "real-estate",
      component: () => import("@/page/realEstate.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/area",
      name: "wp-area",
      component: require("@/page/wpArea").default,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/ad",
      name: "ad",
      component: require("@/page/ad").default,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/locationImage",
      name: "location-image",
      component: require("@/page/makeLocationImage/index.vue").default,
      meta: {
        keepAlive: false,
      },
    },
    {
      path: "/bigScreenMapDisplay",
      name: "big-screen-map-display",
      component: () =>
        import(
          "@/page/newOperateTeam/components/workMaps/bigScreenMap/BigScreenMapDisplay.vue"
        ),
      meta: {
        keepAlive: false,
        title: "大屏幕地图展示",
      },
    },
    {
      path: "/bigScreenEstateModel",
      name: "big-screen-estate-model",
      component: () =>
        import(
          "@/page/newOperateTeam/components/workMaps/bigScreenMap/BigScreenEstateModel.vue"
        ),
      meta: {
        keepAlive: false,
        title: "楼盘3D模型",
      },
    },
    {
      path: "/workMap/plate-content",
      name: "work-map-plate-content",
      component: () =>
        import("@/page/newOperateTeam/components/workMaps/PlateContentMap.vue"),
      meta: {
        keepAlive: false,
        title: "板块地图内容（二手/新房）",
      },
    },
    {
      path: "/workMap/plate-inventory",
      name: "work-map-plate-inventory",
      component: () =>
        import(
          "@/page/newOperateTeam/components/workMaps/PlateInventoryMap.vue"
        ),
      meta: {
        keepAlive: false,
        title: "板块库存分析地图（二手房）",
      },
    },
    {
      path: "/workMap/plate-deal",
      name: "work-map-plate-deal",
      component: () =>
        import("@/page/newOperateTeam/components/workMaps/PlateDealMap.vue"),
      meta: {
        keepAlive: false,
        title: "板块成交量分析地图（二手房）",
      },
    },
    {
      path: "/workMap/plate-area-info",
      name: "work-map-plate-area-info",
      component: () =>
        import(
          "@/page/newOperateTeam/components/workMaps/PlateAreaInfoMap.vue"
        ),
      meta: {
        keepAlive: false,
        title: "板块二手房信息介绍地图",
      },
    },
    {
      path: "/workMap/hangzhou-subway",
      name: "work-map-hangzhou-subway",
      component: () =>
        import(
          "@/page/newOperateTeam/components/workMaps/NewEstateSubwayMap.vue"
        ),
      meta: {
        keepAlive: false,
        title: "杭州新房地铁分布图",
      },
    },
    {
      path: "/workMap/low-density-estate",
      name: "work-map-low-density-estate",
      component: () =>
        import(
          "@/page/newOperateTeam/components/workMaps/LowDensityEstateMap.vue"
        ),
      meta: {
        keepAlive: false,
        title: "低密楼盘分布地图",
      },
    },
    {
      path: "/workMap/luxury-estate",
      name: "work-map-luxury-estate",
      component: () =>
        import("@/page/newOperateTeam/components/workMaps/LuxuryEstateMap.vue"),
      meta: {
        keepAlive: false,
        title: "豪宅楼盘分布地图",
      },
    },
    {
      path: "/workMap/plate-plan-analysis",
      name: "work-map-plate-plan-analysis",
      component: () =>
        import(
          "@/page/newOperateTeam/components/workMaps/PlatePlanAnalysisMap.vue"
        ),
      meta: {
        keepAlive: false,
        title: "板块规划分析图",
      },
    },
    {
      path: "/areaMap",
      name: "area-map",
      component: require("@/page/secondHandArea").default,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/schoolMap",
      name: "school-map",
      component: require("@/page/secHandSchool").default,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/sale",
      name: "sale",
      component: require("@/page/operateTeam/newHouse/consultantReview/sale")
        .default,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/debug",
      name: "debug",
      component: require("@/page/debug").default,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/device-auth/authorize",
      name: "device-trust-authorize",
      component: () => import("@/page/DeviceTrustAuthorize.vue"),
    },
    {
      path: "/device-auth/callback",
      name: "device-trust-callback",
      component: () => import("@/page/DeviceTrustCallback.vue"),
    },
    {
      path: "/vote",
      name: "vote",
      component: vote,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/question",
      name: "question",
      component: question,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/apartment",
      name: "apartment",
      component: () => import("@/page/apartment/apartment.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/subway",
      name: "subway",
      component: subway,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/highway",
      name: "highway",
      component: highway,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/schoolDistrict",
      name: "schoolDistrict",
      component: schoolDistrict,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/drawArea",
      name: "drawArea",
      component: drawArea,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/backup",
      name: "backup",
      component: backup,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/check",
      name: "check",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/check"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/addScore",
      name: "addScore",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/addScore"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/loginWay1",
      name: "loginWay1",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/loginWay1"),
    },
    {
      path: "/sharePAS",
      name: "sharePAS",
      component: () =>
        import(
          "@/page/operateTeam/newHouse/ManagerFunction/sharePeopleAndSort"
        ),
    },
    {
      path: "/addScoreFail",
      name: "addScoreFail",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/addScoreFail"),
    },
    {
      path: "/inviteFri",
      name: "inviteFri",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/inviteFri"),
    },
    {
      path: "/activityCards",
      name: "activityCards",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/activityCards"),
    },
    {
      path: "/deductionPoint",
      name: "deductionPoint",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/deductionPoint"),
    },
    {
      path: "/PYQ",
      name: "PYQ",
      component: () =>
        import("@/page/operateTeam/newHouse/ManagerFunction/pengyouquan"),
    },
    {
      path: "/article",
      name: "article",
      component: () => import("@/page/article"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/saleInfo",
      name: "saleInfo",
      component: () => import("@/page/saleInfo"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/management",
      name: "management",
      component: management,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/RealTable",
      name: "RealTable",
      component: RealTable,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/CheckAsk",
      name: "CheckAsk",
      component: () =>
        import("@/page/operateTeam/newHouse/customerReview/CheckAsk"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/location",
      name: "location",
      component: () => import("@/page/Location"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/fastNews",
      name: "fastNews",
      component: fastNews,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/landPlan",
      name: "landPlan",
      component: landPlan,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/drawLand",
      name: "drawLand",
      component: drawLand,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/dealWant",
      name: "dealWant",
      component: dealWant,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/mapMenu",
      name: "mapMenu",
      component: mapMenu,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/MeiTi",
      name: "MeiTi",
      component: () => import("@/page/MeiTi"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/",
      name: "other",
      component: other,
      meta: {
        keepAlive: true,
        cacheKey: "other-v2",
      },
    },
    {
      path: "/system",
      name: "system",
      component: system,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/activity",
      name: "activity",
      component: () => import("@/page/Activity"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/drawWarn",
      name: "drawWarn",
      component: () =>
        import("@/page/operateTeam/newHouse/customerFunction/DrawWarn"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/cF",
      name: "cF",
      component: () =>
        import("@/page/operateTeam/newHouse/customerFunction/cuFunctions"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/landDeal",
      name: "landDeal",
      component: landDeal,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/verify",
      name: "verify",
      component: () =>
        import("@/page/operateTeam/newHouse/estateType/verify.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/newHousePic",
      name: "newHousePic",
      component: () =>
        import("@/page/operateTeam/newHouse/estateType/newHousePic.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/tEOpening",
      name: "tEOpening",
      component: () =>
        import(
          "@/page/operateTeam/newHouse/estateType/trackExpectedOpening.vue"
        ),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/proComments",
      name: "proComments",
      component: () =>
        import("@/page/operateTeam/newHouse/estateType/propertyComments.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/estateClick",
      name: "estateClick",
      component: () =>
        import("@/page/operateTeam/newHouse/estateType/estateClickSort.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/tinymce",
      name: "tinymce",
      component: () => import("@/page/tinymce"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/HangPai",
      name: "HangPai",
      component: () => import("@/page/HangPai.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/realEstateSchedule",
      name: "realEstateSchedule",
      component: () => import("@/page/realEstateSchedule.vue"),
    },
    {
      path: "/aerialSurvey",
      name: "aerialSurvey",
      component: () => import("@/page/aerialSurvey.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/Customer",
      name: "Customer",
      component: () => import("@/page/Customer.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/AutoReply",
      name: "AutoReply",
      component: AutoReply,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/ChatGroup",
      name: "ChatGroup",
      component: ChatGroup,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/CustomerDistribution",
      name: "CustomerDistribution",
      component: () => import("@/page/CustomerDistribution.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/assignCustomerReviews",
      name: "assignCustomerReviews",
      component: () => import("@/page/assignCustomerReviews.vue"),
    },
    {
      path: "/Zhibo",
      name: "Zhibo",
      component: () => import("@/page/Zhibo.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/GeoChat",
      name: "GeoChat",
      component: GeoChat,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/Shop",
      name: "Shop",
      component: Shop,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/Product",
      name: "Product",
      component: Product,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/CheckVoice",
      name: "CheckVoice",
      component: () =>
        import("@/page/operateTeam/newHouse/customerReview/CheckVoice.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/opinion",
      name: "opinion",
      component: opinion,
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/Task",
      name: "Task",
      component: () => import("@/page/Task.vue"),
      meta: {
        keepAlive: true,
      },
    },
    // 需求中心
    {
      path: "/requirement",
      name: "requirement",
      component: () => import("@/page/requirement/index.vue"),
      redirect: "/requirement/mymission",
      meta: {
        keepAlive: true,
      },
      children: [
        {
          path: "mymission",
          component: () => import("@/page/requirement/components/MyMission"),
        },
        {
          path: "demand",
          component: () => import("@/page/requirement/components/Demand"),
        },
        {
          path: "productpool",
          component: () => import("@/page/requirement/components/ProductPool"),
        },
        {
          path: "designtpool",
          component: () => import("@/page/requirement/components/DesigntPool"),
        },
        {
          path: "taskpool",
          component: () => import("@/page/requirement/components/TaskPool"),
        },
        {
          path: "releasepool",
          component: () => import("@/page/requirement/components/ReleasePool"),
        },
        {
          path: "version",
          component: () => import("@/page/requirement/components/Version"),
        },
        {
          path: "monthlyassessment",
          component: () =>
            import("@/page/requirement/components/MonthlyAssessment"),
        },
        {
          path: "MoudleManage",
          component: () => import("@/page/requirement/components/MoudleManage"),
        },
        {
          path: "project",
          component: () => import("@/page/requirement/components/Project"),
        },
        {
          path: "statistics",
          component: () => import("@/page/requirement/components/Statistics"),
        },
        {
          path: "Experience",
          component: () => import("@/page/requirement/components/Experience"),
        },
        {
          path: "ProductFollowUp",
          component: () =>
            import("@/page/requirement/components/ProductFollowUp"),
        },
        {
          path: "taskTrack",
          component: () => import("@/page/requirement/components/taskTrack"),
        },
      ],
    },
    {
      path: "/FireGroup",
      name: "FireGroup",
      component: FireGroup,
    },
    {
      path: "/MapImage",
      name: "MapImage",
      component: MapImage,
    },
    {
      path: "/BuildingValuation",
      name: "BuildingValuation",
      component: () => import("@/page/BuildingValuation.vue"),
    },
    {
      path: "/downSideValuation",
      name: "downSideValuation",
      component: () => import("@/page/downSideValuation.vue"),
    },
    {
      path: "/kfsAccout",
      name: "kfsAccout",
      component: () => import("@/page/KFSAccout.vue"),
    },
    {
      path: "/Emoticon",
      name: "Emoticon",
      component: () => import("@/page/Emoticon"),
    },
    {
      path: "/PackPaces",
      name: "PackPaces",
      component: () => import("@/page/packpaces.vue"),
    },
    {
      path: "/XHTrend",
      name: "XHTrend",
      component: () => import("@/page/XHTrend.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/demolitionMapData",
      name: "demolitionMapData",
      component: () => import("@/page/demolitionMapData.vue"),
    },
    {
      path: "/estateEvaluationVideo",
      name: "estateEvaluationVideo",
      component: () => import("@/page/estateEvaluationVideo.vue"),
    },
    {
      path: "/xHAppData",
      name: "xHAppData",
      component: () => import("@/page/xHAppData.vue"),
    },
    {
      path: "/channel",
      name: "channel",
      component: () => import("@/page/xinghao/channel.vue"),
    },
    {
      path: "/TrendCheck",
      name: "TrendCheck",
      component: () => import("@/page/xinghao/TrendCheck.vue"),
    },
    {
      path: "/TalkCheck",
      name: "TalkCheck",
      component: () => import("@/page/xinghao/TalkCheck.vue"),
    },
    {
      path: "/OperationsAssistant",
      name: "OperationsAssistant",
      component: () => import("@/page/xinghao/OperationsAssistant.vue"),
    },
    {
      path: "/terminology",
      name: "terminology",
      component: () => import("@/page/ai/terminology.vue"),
    },
    {
      path: "/SearchCheck",
      name: "SearchCheck",
      component: () => import("@/page/ai/SearchCheck.vue"),
    },
    {
      path: "/SingleChat",
      name: "SingleChat",
      component: () => import("@/page/SingleChat.vue"),
    },
    {
      path: "/BusinessGoodsShow",
      name: "BusinessGoodsShow",
      component: () => import("@/page/businessGoodsShow.vue"),
    },
    {
      path: "/BusinessNewGoods",
      name: "BusinessNewGoods",
      component: () => import("@/page/businessNewGoods.vue"),
    },
    {
      path: "/businessReconciliation",
      name: "businessReconciliation",
      component: () => import("@/page/businessReconciliation.vue"),
    },
    {
      path: "/zuwoCenter",
      name: "zuwoCenter",
      component: () => import("@/page/zuwoCenter/index.vue"),
      meta: {
        keepAlive: true,
      },
      children: [
        {
          path: "/zuwoCenter/zuwoFyModify",
          name: "zuwoFyModify",
          component: () => import("@/page/zuwoCenter/zuwoFyModify.vue"),
        },
        {
          path: "/zuwoCenter/zuwoNeighborModify",
          name: "zuwoNeighborModify",
          component: () => import("@/page/zuwoCenter/zuwoNeighborModify.vue"),
        },
        {
          path: "/zuwoCenter/zuwoConsultCount",
          name: "zuwoConsultCount",
          component: () => import("@/page/zuwoCenter/zuwoConsultCount.vue"),
        },
        {
          path: "/zuwoCenter/zuwopinpaigongyushenhe",
          name: "zuwopinpaigongyushenhe",
          component: () =>
            import("@/page/zuwoCenter/zuwopinpaigongyushenhe.vue"),
        },
        {
          path: "/zuwoCenter/zuwoNeighborLandlordNum",
          name: "zuwoNeighborLandlordNum",
          component: () =>
            import("@/page/zuwoCenter/zuwoNeighborLandlordNum.vue"),
        },
        {
          path: "/zuwoCenter/zuwoHouseView",
          name: "zuwoHouseView",
          component: () => import("@/page/zuwoCenter/zuwoHouseView.vue"),
        },
        {
          path: "/zuwoCenter/zuwoHouseCount",
          name: "zuwoHouseCount",
          component: () => import("@/page/zuwoCenter/zuwoHouseCount.vue"),
        },
        {
          path: "/zuwoCenter/zuwoHouseManage",
          name: "zuwoHouseManage",
          component: () => import("@/page/zuwoCenter/zuwoHouseManage.vue"),
        },
        {
          path: "/zuwoCenter/zuwoFyReportModify",
          name: "zuwoFyReportModify",
          component: () => import("@/page/zuwoCenter/zuwoFyReportModify.vue"),
        },
        {
          path: "/zuwoCenter/zuwoUploadHouseCount",
          name: "zuwoUploadHouseCount",
          component: () => import("@/page/zuwoCenter/zuwoUploadHouseCount.vue"),
        },
        {
          path: "/zuwoCenter/zuwoMakeGroup",
          name: "zuwoMakeGroup",
          component: () => import("@/page/zuwoCenter/zuwoMakeGroup.vue"),
        },
        {
          path: "/zuwoCenter/zuwoAgentModify",
          name: "zuwoAgentModify",
          component: () => import("@/page/zuwoCenter/zuwoAgentModify.vue"),
        },
        {
          path: "/zuwoCenter/zuwoApartmentManagerModify",
          name: "zuwoApartmentManagerModify",
          component: () =>
            import("@/page/zuwoCenter/zuwoApartmentManagerModify.vue"),
        },
      ],
    },
    {
      path: "/zukeCenter",
      name: "zukeCenter",
      meta: {
        keepAlive: true,
      },
      redirect: "/zukeCenter/review/consultReview",
      component: () => import("@/page/zukeCenter/index.vue"),
      children: [
        {
          path: "review/consultReview",
          component: () => import("@/page/zukeCenter/review/conReview.vue"),
        },
        {
          path: "review/houseReview",
          component: () => import("@/page/zukeCenter/review/houseReview.vue"),
        },
        {
          path: "review/companyReview",
          component: () => import("@/page/zukeCenter/review/companyReview.vue"),
        },
        {
          path: "review/noteReview",
          component: () => import("@/page/zukeCenter/review/noteReview.vue"),
        },
        {
          path: "review/inNewHouseReview",
          component: () =>
            import("@/page/zukeCenter/review/inNewHouseReview.vue"),
        },
        {
          path: "review/reportReview",
          component: () => import("@/page/zukeCenter/review/reportReview.vue"),
        },
        {
          path: "userInfo/userList",
          component: () => import("@/page/zukeCenter/userInfo/userList.vue"),
        },
        {
          path: "userInfo/agencyList",
          component: () => import("@/page/zukeCenter/userInfo/agencyList.vue"),
        },
        {
          path: "userInfo/companyList",
          component: () => import("@/page/zukeCenter/userInfo/companyList.vue"),
        },
        {
          path: "userInfo/userNoteList",
          component: () =>
            import("@/page/zukeCenter/userInfo/userNoteList.vue"),
        },
        {
          path: "userInfo/houseList",
          component: () => import("@/page/zukeCenter/userInfo/houseList.vue"),
        },
      ],
    },
    {
      path: "/newHouseBoard",
      name: "newHouseBoard",
      component: () => import("@/page/newHouseBoard"),
    },
    {
      path: "/auditList",
      name: "auditList",
      component: () => import("@/page/auditList"),
    },
    {
      path: "/FunctionViewStats",
      name: "FunctionViewStats",
      component: () => import("@/page/FunctionViewStats"),
    },
    {
      path: "/MiniProgramData",
      name: "MiniProgramData",
      component: () => import("@/page/MiniProgramData"),
    },
    {
      path: "/wechatMiniProgramDataTrend",
      name: "wechatMiniProgramDataTrend",
      component: () => import("@/page/WechatMiniProgramDataTrend.vue"),
    },
    {
      path: "/marketComment",
      name: "marketComment",
      component: () => import("@/page/marketComment"),
    },
    {
      path: "/newBuildBoard",
      name: "newBuildBoard",
      component: () => import("@/page/newBuildBoard"),
    },
    {
      path: "/allAccountDetail",
      name: "allAccountDetail",
      component: () => import("@/page/allAccountDetail"),
    },
    {
      path: "/julyBusinessActivity",
      name: "julyBusinessActivity",
      component: () => import("@/page/julyBusinessActivity"),
    },
    {
      path: "/autumnBusinessActivity",
      name: "autumnBusinessActivity",
      component: () => import("@/page/autumnBusinessActivity"),
    },
    {
      path: "/yearEndHomeService",
      name: "yearEndHomeService",
      component: () => import("@/page/yearEndHomeService"),
    },
    {
      path: "/double11BusinessActivity",
      name: "double11BusinessActivity",
      component: () => import("@/page/double11BusinessActivity"),
    },
    {
      path: "/xiaoyangchunActivity",
      name: "xiaoyangchunActivity",
      component: () => import("@/page/xiaoyangchunActivity"),
    },
    {
      path: "/Activity618",
      name: "Activity618",
      component: () => import("@/page/Activity618"),
    },
    {
      path: "/double12BusinessActivity",
      name: "double12BusinessActivity",
      component: () => import("@/page/double12BusinessActivity"),
    },
    {
      path: "/guwenImpactBoard",
      name: "guwenImpactBoard",
      component: () => import("@/page/guwenImpactBoard"),
    },
    {
      path: "/transactionEntry",
      name: "transaction Entry",
      component: () => import("@/page/transactionEntry"),
    },
    {
      path: "/acCustomerList",
      name: "acCustomerList",
      component: () => import("@/page/acCustomerList"),
    },
    {
      path: "/estateHomeInfo",
      name: "estateHomeInfo",
      component: () => import("@/page/estateHomeInfo"),
    },
    {
      path: "/newHouseClickData",
      name: "newHouseClickData",
      component: () => import("@/page/newHouseClickData"),
    },
    {
      path: "/appShareData",
      name: "appShareData",
      component: () => import("@/page/appShareData"),
    },
    {
      path: "/secHandHouseClickData",
      name: "secHandHouseClickData",
      component: () => import("@/page/secHandHouseClickData"),
    },
    {
      path: "/homePageClickData",
      name: "homePageClickData",
      component: () => import("@/page/homePageClickData"),
    },
    {
      path: "/evaluationPageClickData",
      name: "evaluationPageClickData",
      component: () => import("@/page/evaluationPageClickData"),
    },
    {
      path: "/secHouseLpClickData",
      name: "secHouseLpClickData",
      component: () => import("@/page/secHouseLpClickData"),
    },
    {
      path: "/secHandEstateFucData",
      name: "secHandEstateFucData",
      component: () => import("@/page/secHandEstateFucData"),
    },
    {
      path: "/agentConsumeScore",
      name: "agentConsumeScore",
      component: () => import("@/page/agentConsumeScore"),
    },
    {
      path: "/secHandKeyData",
      name: "secHandKeyData",
      component: () => import("@/page/secHandKeyData"),
    },
    {
      path: "/communityData",
      name: "communityData",
      component: () => import("@/page/communityData"),
    },
    {
      path: "/agentPerformanceData",
      name: "agentPerformanceData",
      component: () => import("@/page/agentPerformanceData"),
    },
    // 选房师
    {
      path: "/housePicker/areaPage",
      name: "areaPage",
      component: () => import("@/page/housePicker/areaPage.vue"),
      meta: {
        keepAlive: true,
      },
    },
    {
      path: "/housePicker/lpData",
      name: "lpData",
      component: () => import("@/page/housePicker/lpData.vue"),
    },
    {
      path: "/CooperationManagement",
      name: "CooperationManagement",
      component: () => import("@/page/CooperationManagement"),
    },
    {
      path: "/cooperationList",
      name: "cooperationList",
      component: () => import("@/page/cooperationList"),
    },
    {
      path: "/EstateHousesSearch",
      name: "EstateHousesSearch",
      component: () => import("@/page/EstateHousesSearch.vue"),
    },
    {
      path: "/decorationStatisticsTable",
      name: "decorationStatisticsTable",
      component: () => import("@/page/DecorationStatisticsTable.vue"),
    },
    {
      path: "/ConsultantPaymentDetail",
      name: "ConsultantPaymentDetail",
      component: () => import("@/page/ConsultantPaymentDetail.vue"),
    },
    {
      path: "/priceChangeAnalysis",
      name: "priceChangeAnalysis",
      component: () => import("@/page/priceChangeAnalysis.vue"),
    },
    {
      path: "/newHouseFilter",
      name: "newHouseFilter",
      component: () => import("@/page/newHouseFilter.vue"),
    },
    {
      path: "/shLocationMap",
      component: () => import("@/page/shLocationMap.vue"),
    },
    {
      path: "/trafficRedirect",
      name: "trafficRedirect",
      component: () => import("@/page/trafficRedirect.vue"),
    },
    {
      path: "/publicityRecordInfo",
      name: "publicityRecordInfo",
      component: () => import("@/page/publicityRecordInfo.vue"),
    },
    {
      path: "/sunshineEvaluation",
      name: "sunshineEvaluation",
      component: () => import("@/page/sunshineEvaluation.vue"),
    },
    {
      path: "/poiManage",
      name: "poiManage",
      component: () => import("@/page/PoiManage.vue"),
    },
  ],
});

// 发布后，已打开页面可能仍持有旧 manifest，懒加载时会请求已被替换的
// hash chunk。遇到此类错误时刷新一次，以取得当前版本的入口和 chunk 映射。
// 使用时间窗口而非永久标记，避免资源服务持续异常时形成刷新循环。
const CHUNK_LOAD_RELOAD_KEY = "erp-view:chunk-load-reload-at";
const CHUNK_LOAD_RELOAD_INTERVAL = 5 * 60 * 1000;

router.onError((error) => {
  const message = (error && error.message) || "";
  if (!/(Loading chunk \d+ failed|ChunkLoadError)/i.test(message)) {
    return;
  }

  const now = Date.now();
  const lastReloadAt =
    Number(sessionStorage.getItem(CHUNK_LOAD_RELOAD_KEY)) || 0;
  if (now - lastReloadAt < CHUNK_LOAD_RELOAD_INTERVAL) {
    console.error("异步页面资源加载失败，已自动刷新过一次：", error);
    return;
  }

  sessionStorage.setItem(CHUNK_LOAD_RELOAD_KEY, String(now));
  window.location.reload();
});

router.beforeEach((to, from, next) => {
  let user_type = sessionStorage.getItem("identity") || "";
  // if (to.name == "Customer") {
  //   return;
  // }
  if (user_type !== "系统管理员" && to.name == "debug") {
    return;
  }
  if (
    to.path === "/login" ||
    to.path === "/device-auth/authorize" ||
    to.path === "/device-auth/callback" ||
    to.path === "/debug" ||
    to.path === "/MapImage" ||
    to.path === "/MapScreenshot" ||
    to.path === "/locationImage"
  ) {
    next();
  } else {
    let token = sessionStorage.getItem("Authorization");
    if (token && token != "null" && token != "undefined") {
      if (to.name === "index-page") {
        if (
          user_type !== "系统管理员" &&
          !user_type.includes("数据列表") &&
          !user_type.includes("广告")
        ) {
          return;
        }
      }
      next();
    } else {
      next({
        name: "login",
        params: {
          params: to.params,
          query: to.query,
          name: to.name,
          path: to.fullPath,
        },
      });
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js